import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './slices/cartSlice';
import checkoutReducer from './features/checkoutSlice';
import permissionsReducer from './slices/permissionsSlice';

// Load cart state from localStorage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('cartState');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// Save cart state to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('cartState', serializedState);
  } catch {
    // Ignore write errors
  }
};

const preloadedState = {
  cart: loadState() || {
    items: [],
    totalQuantity: 0,
    totalAmount: 0,
  },
  checkout: {
    selectedPaymentMethod: null,
    bankTransfer: {
      receipt: null
    },
    orderStatus: 'idle',
    error: null
  }
};

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    checkout: checkoutReducer,
    permissions: permissionsReducer
  },
  preloadedState,
});

// Subscribe to store changes
store.subscribe(() => {
  saveState(store.getState().cart);
});

export default store;
